module.exports = __webpack_public_path__ + "static/media/logo_lienviet.d4d3252c.svg";